;(function() {
  'use strict'

  angular.module('app.core').service('portalLayoutService', Service)

  function Service() {
    var self = this

    self.back = null // function | null — invoked when user clicks back
    self.footerHidden = false

    self.setBack = setBack
    self.clearBack = clearBack
    self.hideFooter = hideFooter
    self.showFooter = showFooter

    function setBack(handler) {
      self.back = handler
    }

    function clearBack() {
      self.back = null
    }

    function hideFooter() {
      self.footerHidden = true
    }

    function showFooter() {
      self.footerHidden = false
    }
  }
})()
